// src/helpers/input-filter.ts
var filtresDefaut = [/motPasse/, /compteBancaire/, /^code$/];
var MASK = "*****";
function filtrerInput(input, filtresAdditionnels = []) {
  const newInput = input == null ? input : JSON.parse(JSON.stringify(input));
  const filtres = [
    ...filtresDefaut,
    ...filtresAdditionnels.map((f) => new RegExp(f))
  ];
  cleanObject(newInput, filtres);
  return newInput;
}
function cleanObject(obj, filters) {
  if (typeof obj === "object" && obj != null) {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        cleanObject(obj[key], filters);
      } else {
        if (filters.some((regexp) => regexp.test(key))) {
          obj[key] = MASK;
        }
      }
    });
  }
}

export { MASK, filtrerInput };
//# sourceMappingURL=chunk-IK5UEBSD.js.map
//# sourceMappingURL=chunk-IK5UEBSD.js.map